/**
 * PlayerFinancialsTab public entry point.
 * Re-exports the container to provide a stable import path.
 * @module features/player-detail/components/PlayerFinancialsTab
 */
export { default } from "./PlayerFinancialsTabContainer";
